var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50034 9.13664L1.97969 14.6573C1.52614 15.1108 0.791506 15.1122 0.339316 14.6614C-0.115589 14.2051 -0.111515 13.4745 0.342032 13.021L5.86404 7.50034L0.342032 1.97969C-0.110157 1.52614 -0.112873 0.791506 0.339316 0.339316C0.794222 -0.115589 1.52614 -0.111515 1.97969 0.342032L7.50034 5.86404L13.021 0.342032C13.4745 -0.110157 14.2092 -0.112873 14.6614 0.339316C15.1163 0.794222 15.1108 1.52614 14.6573 1.97969L9.13664 7.50034L14.6573 13.021C15.1108 13.4745 15.1122 14.2092 14.6614 14.6614C14.2051 15.1163 13.4745 15.1108 13.021 14.6573L7.50034 9.13664Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.961beb32952ca55cf54fcf409d9506d0.svg";
export { ForwardRef as ReactComponent };